import * as React from "react";
import { logger } from "../../utilities/logger";
import Box from "@mui/material/Box";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import FormLabel from "@mui/material/FormLabel";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
//import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import MuiCard from "@mui/material/Card";
import { styled } from "@mui/material/styles";
import AppTheme from "../../theme/AppTheme";
import Logo from '../../assests/images/logo2.png';
import { LoginService } from "../../services/LoginService";
import { InputAdornment } from '@mui/material'
import IconButton from '@mui/material/IconButton';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import {
  useForm,
  Controller,
} from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

const Card = styled(MuiCard)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignSelf: "center",
  width: "100%",
  padding: theme.spacing(4),
  gap: theme.spacing(2),
  margin: "auto",
  [theme.breakpoints.up("sm")]: {
    maxWidth: "450px",
  },
  boxShadow:
    "hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px",
  ...theme.applyStyles("dark", {
    boxShadow:
      "hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px",
  }),
}));

const ForgotPasswordContainer = styled(Stack)(({ theme }) => ({
  height: "calc((1 - var(--template-frame-height, 0)) * 100dvh)",
  minHeight: "100%",
  padding: theme.spacing(2),
  [theme.breakpoints.up("sm")]: {
    padding: theme.spacing(4),
  },
  "&::before": {
    content: '""',
    display: "block",
    position: "absolute",
    zIndex: -1,
    inset: 0,
    backgroundImage:
      "radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))",
    backgroundRepeat: "no-repeat",
    ...theme.applyStyles("dark", {
      backgroundImage:
        "radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))",
    }),
  },
}));

export default function ForgotPassword(props) {
  const emailError = false;
  const emailErrorMessage = "";
  const errorMessage = "";
  const [displayPasswordText, setDisplayPasswordText] = React.useState(false);
  const [email, setEmail] = React.useState('');
  const [emailTouched, setEmailTouched] = React.useState(false);
  const [isdisabledEmail, setIsdisabledEmail] = React.useState(false);

  const [showNewPassword, setShowNewPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
  const [snackbar, setSnackbar] = React.useState({ open: false, message: "", severity: "info" });
  const notify = (message, severity = "info") => setSnackbar({ open: true, message, severity });
  const handleSnackbarClose = (_, reason) => { if (reason !== "clickaway") setSnackbar(prev => ({ ...prev, open: false })); };


  const schema = yup.object().shape({
    newPassword: yup
      .string()
      .required('New Password is required')
      .min(6, 'Password must be at least 6 characters'),
    confirmNewPassword: yup
      .string()
      .oneOf([yup.ref('newPassword')], 'Passwords must match')
      .required('Confirm Password is required'),
  });

  const {
    control,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  });

  const onSubmit = async (data) => {
    try {
      const result = await LoginService.ResetPassword(email, data.confirmNewPassword);
      if (result) {
        notify('Password reset successfully!', 'success');
        setTimeout(() => { window.location.pathname = "/login"; }, 1500);
      }
    } catch (error) {
      logger.error("Password reset failed:", error);
    }
  };

  const toggleNewPasswordVisibility = () => setShowNewPassword((prev) => !prev);
  const toggleConfirmPasswordVisibility = () => setShowConfirmPassword((prev) => !prev);

  const isValidEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  React.useEffect(() => {
    if (emailTouched && isValidEmail(email)) {
      // Call your API here
      const fetchData = async () => {
        try {
          const response = await LoginService.CheckEmailExistOrNot(email);
          if (response) {
            setDisplayPasswordText(true);
            setIsdisabledEmail(true);
          } else {
            notify('Email does not exist!', 'warning');
          }
        } catch (err) {
          logger.error('Error fetching email info:', err);
        }
      };
      fetchData();
    }
  }, [email, emailTouched]);

  const hanldeEmailChange = (event) => {
    setEmail(event.target.value);
    setEmailTouched(true);
  };

  return (
    <AppTheme {...props}>
      <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={handleSnackbarClose} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} variant="filled" sx={{ width: "100%" }}>{snackbar.message}</Alert>
      </Snackbar>
      <form onSubmit={handleSubmit(onSubmit)}>
        <CssBaseline enableColorScheme />
        <ForgotPasswordContainer
          direction="column"
          justifyContent="space-between"
        >
          <Card variant="outlined" sx={{ img: { textAlign: "center" } }}>
            <img
              width="240"
              height="125"
              style={{ marginLeft: "auto", marginRight: "auto", widht: "50%" }}
              src={Logo}
              alt="Design Logo"
            ></img>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                gap: 2,
              }}
            >
              <FormControl>
                <FormLabel htmlFor="email">Email</FormLabel>
                <TextField
                  error={emailError}
                  helperText={emailErrorMessage}
                  id="email"
                  type="email"
                  name="email"
                  value={email}
                  placeholder="username@cbdbarrie.com"
                  autoComplete="email"
                  autoFocus
                  required
                  fullWidth
                  disabled={isdisabledEmail}
                  variant="outlined"
                  color={emailError ? "error" : "primary"}
                  onChange={(e) => hanldeEmailChange(e)}
                />
              </FormControl>
              <Box sx={{ display: displayPasswordText ? "flex" : "none", flexDirection: "column", gap: 2 }}>
                <FormControl fullWidth margin="normal">
                  <FormLabel htmlFor="newPassword">New Password</FormLabel>
                  <Controller
                    name="newPassword"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextField
                        {...field}
                        type={showNewPassword ? "text" : "password"}
                        id="newPassword"
                        placeholder="••••••"
                        autoComplete="new-password"
                        fullWidth
                        variant="outlined"
                        error={!!errors.newPassword}
                        helperText={errors.newPassword?.message}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={toggleNewPasswordVisibility}
                                edge="end"
                                size="small"
                              >
                                {showNewPassword ? (
                                  <VisibilityOutlinedIcon />
                                ) : (
                                  <VisibilityOffOutlinedIcon />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    )}
                  />
                </FormControl>

                {/* Confirm Password Field */}
                <FormControl fullWidth margin="normal">
                  <FormLabel htmlFor="confirmNewPassword">
                    Confirm New Password
                  </FormLabel>
                  <Controller
                    name="confirmNewPassword"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextField
                        {...field}
                        type={showConfirmPassword ? "text" : "password"}
                        id="confirmNewPassword"
                        placeholder="••••••"
                        autoComplete="new-password"
                        fullWidth
                        variant="outlined"
                        error={!!errors.confirmNewPassword}
                        helperText={errors.confirmNewPassword?.message}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={toggleConfirmPasswordVisibility}
                                edge="end"
                                size="small"
                              >
                                {showConfirmPassword ? (
                                  <VisibilityOutlinedIcon />
                                ) : (
                                  <VisibilityOffOutlinedIcon />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    )}
                  />
                </FormControl>
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <Button
                    type="submit"
                    variant="contained"
                    style={{ backgroundColor: "#bda485", fontWeight: "bold" }}
                  >
                    Reset Password
                  </Button>
                </Box>
              </Box>
              {errorMessage.value && (
                <p style={{ color: "hsl(0, 90%, 40%)" }}>
                  {" "}
                  {errorMessage.value}{" "}
                </p>
              )}
            </Box>
          </Card>
        </ForgotPasswordContainer>
      </form>
    </AppTheme>
  );
}
